import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { ItemSidebar } from '../../../../config/interfaces';
import { setOpenAlertMenu } from '../../../../hooks/actions';
import NavAdminItemChild from './nav-item-child';

const NavAdminItem = (props: ItemSidebar) => {
  const {
    href,
    icon,
    title,
    active,
    child,
  } = props;
  const colorValue = active ? '#FEB100' : '#FFF';
  const navigate = useNavigate();

  return (
    <>
      {
        child
          ? <NavAdminItemChild item={props} key={title} />
          : (
            <ListItemButton
              onClick={() => {
                setOpenAlertMenu(false);
                navigate(href);
              }}
              sx={{ color: colorValue }}
              key={title}
            >
              <ListItemIcon>
                {icon(active)}
              </ListItemIcon>
              <ListItemText primary={title} />
            </ListItemButton>
          )
      }
    </>
  );
};

export default NavAdminItem;
